import axios from "axios";
import { getToken, removeToken } from "@/utils/setToken.js";
import router from "./router";
import { Promise } from "core-js";
import { Message } from "element-ui";
import store from "@/store";
import nprogress from "nprogress";
import "nprogress/nprogress.css";

const service = axios.create({
  baseURL: "/api",
  timeout: 600000,
});

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = getToken("token");
    if (token) {
      config.headers.token = token;
    }
    config.headers.Authorization = `Bearer ${token}`;
    nprogress.start();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做些什么
    let { status } = response;
    if (status !== 200) {
      Message({ message: message || "error", type: "warning" });
    }
    nprogress.done();
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      removeToken("token");
      store.state.auth.token = "";
      location.reload()
      router.push("/login");
    } else {
      return Promise.reject(error);
    }
  }
);

export default service;
